import { OfferList } from './components/OfferList';
import { Route, Routes } from 'react-router-dom';
import { OfferEdit } from './components/OfferEdit';
import { OfferEvents } from './components/OfferEvents';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function OfferRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.OFFERS) && (
                <>
                    <Route index element={<OfferList />} />
                    <Route path="edit/:offerId" element={<OfferEdit />} />
                    <Route path="events/:offerId" element={<OfferEvents />} />
                </>
            )}
        </Routes>
    );
}
